export const FilterSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.447 18.405C10.6126 18.3238 10.7521 18.1979 10.8499 18.0415C10.9476 17.8851 10.9996 17.7044 11 17.52V12.2C11 11.938 11.105 11.686 11.293 11.5L17.414 5.44602C17.789 5.07502 18 4.57102 18 4.04602V1.49002C17.9995 1.35931 17.9732 1.23 17.9226 1.10947C17.8721 0.988942 17.7982 0.879569 17.7053 0.787613C17.6124 0.695656 17.5023 0.622922 17.3813 0.573572C17.2603 0.524223 17.1307 0.499228 17 0.500018H1C0.447 0.500018 0 0.942018 0 1.49002V4.04602C0 4.57102 0.211 5.07502 0.586 5.44602L6.707 11.5C6.79974 11.5915 6.8734 11.7005 6.92369 11.8206C6.97399 11.9408 6.99993 12.0698 7 12.2V18.51C7 19.245 7.782 19.723 8.447 19.394L10.447 18.405Z"
        fill="#3E4685"
      />
    </svg>
  )
}